import React, { Component } from "react";
import {
  NavBar,
  Icon,
  List,
  WingBlank,
  WhiteSpace,
  Button,
  Radio,
  Pagination,
} from "antd-mobile";
import axios from "../../../service/axios";
import { connect } from "dva";
const RadioItem = Radio.RadioItem

export class SelectGroup extends Component {
  state = {
    groupDatas: [],
    pageTotalNum: 0,
    pageNo: 1,
  };
  onChange = e => {
    console.log(e);
    console.log(this.props)
    this.props.addDefaultGroup(e)
  };
  componentDidMount() {
    this.getGroupList(1);
  }
  getGroupList(e) {
    console.log('this.props.uid', this.props.uid)
    axios
      .get("/api/user/ptt/no_groups", {
        params: {
          pageSize: 10,
          pageNo: e,
          uid: this.props.uid
        }
      })
      .then(res => {
        console.log(res);
        if (res && res.status == 200 && res.data) {
          this.setState({
            groupDatas: res.data.resultList.map(item => {
              item.checked = false;
              return item;
            }),
            pageNo: res.data.pageNo,
            pageTotalNum: Math.ceil(res.data.totalCount / 10),
          });
        }
      })
      .catch(res => {
      });
  }
  onPageChange(e) {
    this.getGroupList(e);
  }

  render() {
    const {
      groupDatas,
      pageTotalNum,
      pageNo,
    } = this.state;
    const {
      defaultGroup,
    } = this.props;

    return (
      <div className="selectUser">
        <div
          className="sub-container"
          style={{
            height: document.body.clientHeight - 45,
            overflow: "scroll"
          }}
        >
          <List renderHeader={() => "请选择群组"}>
            {groupDatas.map((i, index) => (
              <RadioItem
                key={i.gid}
                extra={<Icon type="cross" />}
                checked={defaultGroup.gid === i.gid}
                onChange={() => this.onChange(i)}
              >
                {i.gid}-{i.name}
              </RadioItem>
            ))}
          </List>
          <WhiteSpace size="xl" />
          <WingBlank>
            {pageTotalNum > 0 ? (
              <Pagination
                total={pageTotalNum}
                current={pageNo}
                showTotal="12"
                locale={{
                  prevText: "上一页",
                  nextText: "下一页"
                }}
                onChange={e => this.onPageChange(e)}
              />
            ) : (
              ""
            )}
          </WingBlank>
          <div className="footer">
            <span>
              已选:
              {defaultGroup ? defaultGroup.name : ''}
            </span>
            <Button
              type="warning"
              inline
              size="small"
              onClick={() => this.props.handleChildClose()}
            >
              返回
            </Button>
            <Button
              disabled={!defaultGroup}
              type="primary"
              inline
              size="small"
              onClick={() => this.props.handleChildClose()}
            >
              确定
            </Button>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
  };
};

const mapDispatchToProps = dispatch => {
  return {
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SelectGroup);
